"use strict";
var r, a;
function e() {
  return a || (a = 1, r = Math.max), r;
}
export {
  e as __require
};
//# sourceMappingURL=index.es312.js.map
